<div class="sentiment-details-theme-breakup-bars">
  <div class="sentiment-details-theme-breakup-bars__header">
    <h4 class="sentiment-details-theme-breakup-bars__title">Theme break-up</h4>
    <div
      *ngIf="hasAnySuggestedTheme"
      class="sentiment-details-theme-breakup-bars__suggested-wrap"
      title="Switch between standard themes and suggested themes"
    >
      <span class="sentiment-details-theme-breakup-bars__suggested-label">Suggested</span>
      <button
        type="button"
        class="sentiment-details-theme-breakup-bars__switch"
        [class.sentiment-details-theme-breakup-bars__switch--on]="showSuggestedThemesOnly"
        role="switch"
        [attr.aria-checked]="showSuggestedThemesOnly"
        (click)="onSuggestedThemesToggle()"
      >
        <span class="sentiment-details-theme-breakup-bars__switch-knob"></span>
      </button>
    </div>
  </div>
  <div class="sentiment-details-theme-breakup-bars__list" *ngIf="themesRows.length">
    <div
      *ngFor="let t of themesRows; trackBy: trackByThemeId"
      class="sentiment-details-theme-breakup-bars__item"
      [class.sentiment-details-theme-breakup-bars__item--selected]="selectedThemeId === t.themeId"
    >
      <div class="sentiment-details-theme-breakup-bars__item-head">
        <span class="sentiment-details-theme-breakup-bars__item-label">{{ t.themeName }}</span>
        <span class="sentiment-details-theme-breakup-bars__info" title="View details" role="button" tabindex="0" (click)="onThemeInfoClick(t); $event.stopPropagation()" (keydown.enter)="onThemeInfoClick(t)" (keydown.space)="$event.preventDefault(); onThemeInfoClick(t)">i</span>
      </div>
      <div
        class="sentiment-details-theme-breakup-bars__bar sentiment-details-theme-breakup-bars__bar--clickable"
        (mousedown)="$event.preventDefault()"
        (click)="onThemeBarClick(t)"
        role="button"
        tabindex="0"
        (keydown.enter)="onThemeBarClick(t)"
        (keydown.space)="$event.preventDefault(); onThemeBarClick(t)"
      >
        <span
          class="sentiment-details-theme-breakup-bars__seg sentiment-details-theme-breakup-bars__seg--positive"
          [style.width.%]="t.positive"
          [title]="'Positive: ' + (t.positive | number:'1.1-1') + '% (' + (t.positiveCount | number) + ')'"
        ></span>
        <span
          class="sentiment-details-theme-breakup-bars__seg sentiment-details-theme-breakup-bars__seg--neutral"
          [style.width.%]="t.neutral"
          [title]="'Neutral: ' + (t.neutral | number:'1.1-1') + '% (' + (t.neutralCount | number) + ')'"
        ></span>
        <span
          class="sentiment-details-theme-breakup-bars__seg sentiment-details-theme-breakup-bars__seg--negative"
          [style.width.%]="t.negative"
          [title]="'Negative: ' + (t.negative | number:'1.1-1') + '% (' + (t.negativeCount | number) + ')'"
        ></span>
      </div>
    </div>
  </div>
  <p class="sentiment-details-theme-breakup-bars__empty" *ngIf="!themesRows.length">No theme data</p>
</div>
